class QNCollectionsIconsCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-qn-ci-track]');
    this.dotsWrap = container.querySelector('[data-qn-ci-dots]');
    this.slides = Array.from(container.querySelectorAll('.qn-collections-icons__slide'));
    this.currentIndex = 0;

    if (!this.container || !this.track || !this.slides.length) return;

    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);

    this.init();
  }

  isMobile() {
    return window.innerWidth <= 767;
  }

 visibleItems() {
  return 1;
}

  pageCount() {
    return Math.max(1, Math.ceil(this.slides.length / this.visibleItems()));
  }

  slideWidth() {
    const firstSlide = this.slides[0];
    return firstSlide ? firstSlide.getBoundingClientRect().width : 0;
  }

  pageWidth() {
    return this.slideWidth() * this.visibleItems();
  }

  maxIndex() {
    return this.pageCount() - 1;
  }

  init() {
    this.buildDots();

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.track.scrollLeft = 0;

    this.update();
  }

  buildDots() {
    if (!this.dotsWrap) return;

    this.dotsWrap.innerHTML = '';

    for (let i = 0; i < this.pageCount(); i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'qn-collections-icons__mobile-dot';
      dot.setAttribute('aria-label', `Ir al slide ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
    }
  }

  goTo(index) {
    if (!this.isMobile()) return;

    const clamped = Math.max(0, Math.min(index, this.maxIndex()));
    this.currentIndex = clamped;

    this.track.scrollTo({
      left: this.pageWidth() * clamped,
      behavior: 'smooth'
    });

    this.update();
  }

  onScroll() {
    if (!this.isMobile()) return;

    const width = this.pageWidth();
    if (!width) return;

    const index = Math.round(this.track.scrollLeft / width);
    if (index !== this.currentIndex) {
      this.currentIndex = Math.max(0, Math.min(index, this.maxIndex()));
      this.update();
    }
  }

  onResize() {
    this.buildDots();

    if (!this.isMobile()) {
      this.currentIndex = 0;
      this.track.scrollLeft = 0;
    } else {
      this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.maxIndex()));
    }

    this.update();
  }

  update() {
    const mobile = this.isMobile();
    const dots = this.dotsWrap ? Array.from(this.dotsWrap.children) : [];

    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', mobile && index === this.currentIndex);
    });
  }
}

function initQNCollectionsIconsCarousel(scope = document) {
  const carousels = scope.querySelectorAll('[data-qn-ci-carousel]');

  carousels.forEach((carousel) => {
    if (carousel.dataset.qnCiInit === 'true') return;
    carousel.dataset.qnCiInit = 'true';
    new QNCollectionsIconsCarousel(carousel);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initQNCollectionsIconsCarousel(document);
});

document.addEventListener('shopify:section:load', (event) => {
  initQNCollectionsIconsCarousel(event.target);
});